module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAAAXNSR0IArs4c6QAAALVJREFUSEvt1TsKwkAUheEvYGnhcgQF12AhWFi6CJegq7CyU3ADFmKhy7Gws1ACCWgwT0kw4G3nzD2cf+7MBBqooAEPP2myxhQz7IpSKJvkjg72GNdl8oga/00KEW4Prh4G0QR9ihYeeFgXLFOyX3F8XUuO8Bn9QuCyRQusYknS5IRh3SZdjL7EdcMhC1deiPZM1z9JJoGqT/0Wkzy2afckb1/8ac2xyRNXNSna901XFtfvmjwBKH8oGUKMcPoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/icon-add.png
// module id = mAfQ
// module chunks = 1